/**
 * Super-admin "log in as" support. We stash the admin's own token, swap in the
 * impersonation token, and full-reload so AuthContext re-initialises as the
 * target user. A banner (ImpersonationBanner) offers "Return to admin", which
 * restores the stashed token.
 */
const TOKEN_KEY = "auth_token";
const ACTIVE_WS_KEY = "active_workspace_id";
const BACKUP_KEY = "admin_token_backup";
const MARKER_KEY = "impersonating_as";

export interface ImpersonationMarker {
  name: string;
  email: string;
}

export function startImpersonation(token: string, user: ImpersonationMarker) {
  const adminToken = localStorage.getItem(TOKEN_KEY);
  if (adminToken) sessionStorage.setItem(BACKUP_KEY, adminToken);
  sessionStorage.setItem(MARKER_KEY, JSON.stringify(user));
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.removeItem(ACTIVE_WS_KEY); // re-resolve to the target's workspace
  window.location.assign("/vault");
}

export function stopImpersonation() {
  const adminToken = sessionStorage.getItem(BACKUP_KEY);
  sessionStorage.removeItem(BACKUP_KEY);
  sessionStorage.removeItem(MARKER_KEY);
  localStorage.removeItem(ACTIVE_WS_KEY);
  if (adminToken) localStorage.setItem(TOKEN_KEY, adminToken);
  else localStorage.removeItem(TOKEN_KEY);
  window.location.assign("/admin/users");
}

export function getImpersonation(): ImpersonationMarker | null {
  const raw = sessionStorage.getItem(MARKER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ImpersonationMarker;
  } catch {
    return null;
  }
}
